import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const fetchSprint = (cohortId: string, language: string, setSprints: Function, setLoading: Function) => {
  setLoading(true);
  ApiService.get(`cohorts/${cohortId}/sprints`)
    .then((resp) => setSprints(resp.data.sprints || []))
    .catch((error) => {
      setSprints([]);
      console.error(error);
      alert(translate(language, "PAGES.COHORT.SPRINT.ERROR_FETCH"));
    })
    .finally(() => setLoading(false));
};

export const saveSprints = (cohortId: string, sprintsEdited: any[], language: string, callback?: Function) => {
  const newSprints = sprintsEdited.map((sprintData: any, index: number) => ({
    id: sprintData.sprint?.id || undefined,
    name: sprintData.sprint.name,
    start: ~~(new Date(sprintData.sprint.dt_start).getTime() / 1000),
    end: ~~(new Date(sprintData.sprint.dt_end).getTime() / 1000),
    modules: sprintData.modules.map((moduleData: any) => ({
      id: moduleData.module,
      is_mandatory: moduleData.is_mandatory,
    })),
  }));

  ApiService.put(`cohorts/${cohortId}/sprints`, { sprints: newSprints })
    .then(() => {
      callback?.();
    })
    .catch((error) => {
      console.error(error);
      alert(translate(language, "PAGES.COHORT.SPRINT.SAVE_ERROR"));
    });
};
